<template>
  <div class="nav-container" :class="{ 'is-mobile': isMobile }">
    <!-- 电脑端侧边导航 -->
    <div v-if="!isMobile" class="desktop-nav">
      <div class="nav-header">
        <div class="update-meter">
          <div class="meter-top">
            <span class="meter-label">DATA F&M</span>
            <span class="meter-state">ONLINE</span>
          </div>
          <div class="meter-main">
            <span class="car-glyph" aria-hidden="true">
              <svg viewBox="0 0 76 32" focusable="false">
                <path class="car-body" d="M7 21.5h5.7l6-6.4c2-2.1 4.2-3.1 7.2-3.1h18.9c3.2 0 5.8 1 8.2 3.1l6.9 6.1 7.2 1.2c2.4.4 4 2.1 4 4v1.1c0 .8-.7 1.5-1.5 1.5h-8.2a4.8 4.8 0 0 0-9.4 0H24.3a4.8 4.8 0 0 0-9.4 0H6.8c-1 0-1.8-.8-1.8-1.8V24c0-1.3.8-2.2 2-2.5Z" />
                <path class="car-window" d="M24.1 14.3h11.3v6.1H16.8l4.1-4.4c.9-1 1.9-1.7 3.2-1.7Zm14 0h6.5c2.1 0 3.7.6 5.2 1.9l4.8 4.2H38.1v-6.1Z" />
                <path class="car-light" d="M63.2 22.5h5.5c.8.2 1.4.8 1.7 1.5h-6.1c-.8 0-1.1-.7-1.1-1.5Z" />
                <path class="car-emblem" d="M32.6 22.3 36 19l3.4 3.3-3.4 3.3-3.4-3.3Z" />
                <circle class="car-wheel" cx="19.6" cy="28.7" r="3.3" />
                <circle class="car-wheel" cx="56.7" cy="28.7" r="3.3" />
              </svg>
            </span>
            <span class="meter-copy">
              <span class="meter-text">站点最近更新</span>
              <strong>20260601</strong>
            </span>
          </div>
          <div class="meter-track">
            <span></span>
          </div>
        </div>
      </div>

      <el-menu :default-active="activeIndex" class="el-menu-vertical-demo custom-menu" @open="handleOpen" @close="handleClose">
        <el-menu-item
          v-for="item in permissionMenuItems"
          :key="item.index"
          :index="String(item.index)"
          :disabled="item.state === 'disabled'"
          @click="handleMenuItemClick(item)"
        >
          <el-icon>
            <component :is="item.icon" />
          </el-icon>
          <span>{{ item.label }}</span>
        </el-menu-item>
      </el-menu>

      <el-menu v-if="false" :default-active="activeIndex" class="el-menu-vertical-demo custom-menu" @open="handleOpen" @close="handleClose">
        <el-menu-item index="1" @click="handleNavClick('DataDisplay')">
          <el-icon>
            <Tickets />
          </el-icon>
          <span>在线诊断日志</span>
        </el-menu-item>

        <el-menu-item v-if="showFordConfigMenu" index="2" @click="handleNavClick('FordConfig')">
          <el-icon>
            <Setting />
          </el-icon>
          <span>Ford 配置</span>
        </el-menu-item>

        <el-menu-item index="3" @click="handleNavClick('TestSn')">
          <el-icon>
            <Avatar />
          </el-icon>
          <span>测试接头</span>
        </el-menu-item>

        <el-menu-item index="4" @click="handleNavClick('SnMycarInfo')">
          <el-icon>
            <Key />
          </el-icon>
          <span>接头配置</span>
        </el-menu-item>
        <!--         
        <el-menu-item index="3" @click="handleNavClick('OutCode')">
          <el-icon><Key /></el-icon>
          <span>防盗内码</span>
        </el-menu-item>
         -->
        <el-menu-item index="5" @click="handleNavClick('BlackSn')">
          <el-icon>
            <Lock />
          </el-icon>
          <span>黑名单</span>
        </el-menu-item>

        <el-menu-item index="6" @click="handleNavClick('VinList')">
          <el-icon>
            <Star />
          </el-icon>
          <span>VIN数据</span>
        </el-menu-item>

        <el-menu-item v-if="showDataSwitchMenu" index="7" @click="handleNavClick('DataSwitch')">
          <el-icon>
            <Connection />
          </el-icon>
          <span>数据转存</span>
        </el-menu-item>

        <el-menu-item index="8" @click="handleNavClick('VinIMMO')">
          <el-icon>
            <CollectionTag />
          </el-icon>
          <span>防盗VIN数据</span>
        </el-menu-item>

        <el-menu-item index="9" @click="handleNavClick('FileDownload')">
          <el-icon>
            <Download />
          </el-icon>
          <span>下载与维护</span>
        </el-menu-item>

        <el-menu-item index="10" @click="handleNavClick('DeliverFunction')">
          <el-icon>
            <Operation />
          </el-icon>
          <span>Deliver查询</span>
        </el-menu-item>

        <el-menu-item index="11" @click="handleMazdaAllClick()">
          <el-icon>
            <Suitcase />
          </el-icon>
          <span>马自达综合</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 手机端1列布局 -->
    <div v-else class="mobile-nav">
      <!-- 顶部标题 -->
      <div class="mobile-header">
        <div class="mobile-update-meter">
          <span class="meter-label">VEHICLE DATA ONLINE</span>
          <div class="meter-main">
            <span class="car-glyph" aria-hidden="true">
              <svg viewBox="0 0 76 32" focusable="false">
                <path class="car-body" d="M7 21.5h5.7l6-6.4c2-2.1 4.2-3.1 7.2-3.1h18.9c3.2 0 5.8 1 8.2 3.1l6.9 6.1 7.2 1.2c2.4.4 4 2.1 4 4v1.1c0 .8-.7 1.5-1.5 1.5h-8.2a4.8 4.8 0 0 0-9.4 0H24.3a4.8 4.8 0 0 0-9.4 0H6.8c-1 0-1.8-.8-1.8-1.8V24c0-1.3.8-2.2 2-2.5Z" />
                <path class="car-window" d="M24.1 14.3h11.3v6.1H16.8l4.1-4.4c.9-1 1.9-1.7 3.2-1.7Zm14 0h6.5c2.1 0 3.7.6 5.2 1.9l4.8 4.2H38.1v-6.1Z" />
                <path class="car-light" d="M63.2 22.5h5.5c.8.2 1.4.8 1.7 1.5h-6.1c-.8 0-1.1-.7-1.1-1.5Z" />
                <path class="car-emblem" d="M32.6 22.3 36 19l3.4 3.3-3.4 3.3-3.4-3.3Z" />
                <circle class="car-wheel" cx="19.6" cy="28.7" r="3.3" />
                <circle class="car-wheel" cx="56.7" cy="28.7" r="3.3" />
              </svg>
            </span>
            <span class="meter-copy">
              <span class="meter-text">站点最近更新</span>
              <strong>20260601</strong>
            </span>
          </div>
        </div>
      </div>

      <!-- 1列菜单列表 -->
      <div class="menu-list">
        <div
          v-for="item in permissionMenuItems"
          :key="item.index"
          class="list-item"
          :class="{ disabled: item.state === 'disabled' }"
          @click="handleMobileMenuItemClick(item)"
        >
          <div class="item-left">
            <div class="item-icon" :class="item.colorClass">
              <el-icon :size="22">
                <component :is="item.icon" />
              </el-icon>
            </div>
            <span class="item-label">{{ item.label }}</span>
          </div>
          <el-icon class="item-arrow">
            <ArrowRight />
          </el-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 导入 Element Plus 的图标组件  
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import { isSgmUser, isSsvipUser, menuItemState } from "@/utils/adminAccess.mjs";
import {
  Key,
  Avatar,
  Tickets,
  Lock,
  Star,
  Connection,
  CollectionTag,
  Download,
  Suitcase,
  ArrowRight,
  Operation,
  Setting,
} from "@element-plus/icons-vue";

export default {
  name: "NavBar",
  components: {
    Key,
    Avatar,
    Tickets,
    Lock,
    Star,
    Connection,
    CollectionTag,
    Download,
    Suitcase,
    ArrowRight,
    Operation,
    Setting,
  },
  emits: ["nav-click"],
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    // 响应式判断手机端
    const isMobile = ref(window.innerWidth <= 768);
    const showDataSwitchMenu = false;
    const showFordConfigMenu = computed(() => isSsvipUser(store.state.userData));

    const handleResize = () => {
      isMobile.value = window.innerWidth <= 768;
    };

    onMounted(() => {
      window.addEventListener('resize', handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    // 所有菜单项 - 移除所有 badge 相关
    const allMenuItems = computed(() => [
      { index: 1, label: '在线诊断日志', icon: Tickets, name: 'DataDisplay', colorClass: 'blue' },
      ...(showFordConfigMenu.value ? [{ index: 2, label: 'Ford 配置', icon: Setting, name: 'FordConfig', colorClass: 'teal' }] : []),
      { index: 3, label: '测试接头', icon: Avatar, name: 'TestSn', colorClass: 'orange' },
      { index: 4, label: '接头配置', icon: Key, name: 'SnMycarInfo', colorClass: 'green' },
      //{ index: 3, label: '防盗内码', icon: Key, name: 'OutCode', colorClass: 'green' },
      { index: 5, label: '黑名单', icon: Lock, name: 'BlackSn', colorClass: 'red' },
      { index: 6, label: 'VIN数据', icon: Star, name: 'VinList', colorClass: 'purple' },
      ...(showDataSwitchMenu ? [{ index: 7, label: '数据转存', icon: Connection, name: 'DataSwitch', colorClass: 'cyan' }] : []),
      { index: 8, label: '防盗VIN数据', icon: CollectionTag, name: 'VinIMMO', colorClass: 'pink' },
      { index: 9, label: '下载与维护', icon: Download, name: 'FileDownload', colorClass: 'indigo' },
      { index: 10, label: 'Deliver查询', icon: Operation, name: 'DeliverFunction', colorClass: 'brown' },
      { index: 11, label: '马自达综合', icon: Suitcase, name: 'Mazda', colorClass: 'brown' },
    ]);

    const rawPermissionMenuItems = [
      { index: 1, label: '在线诊断日志', icon: Tickets, name: 'DataDisplay', colorClass: 'blue' },
      { index: 2, label: 'Ford 配置', icon: Setting, name: 'FordConfig', colorClass: 'teal' },
      { index: 3, label: '测试接头', icon: Avatar, name: 'TestSn', colorClass: 'orange' },
      { index: 4, label: '接头配置', icon: Key, name: 'SnMycarInfo', colorClass: 'green' },
      { index: 5, label: '黑名单', icon: Lock, name: 'BlackSn', colorClass: 'red' },
      { index: 6, label: 'VIN数据', icon: Star, name: 'VinList', colorClass: 'purple' },
      { index: 7, label: '数据转存', icon: Connection, name: 'DataSwitch', colorClass: 'cyan', enabled: showDataSwitchMenu },
      { index: 8, label: '防盗VIN数据', icon: CollectionTag, name: 'VinIMMO', colorClass: 'pink' },
      { index: 9, label: '下载与维护', icon: Download, name: 'FileDownload', colorClass: 'indigo' },
      { index: 10, label: 'Deliver查询', icon: Operation, name: 'DeliverFunction', colorClass: 'brown' },
      { index: 11, label: '马自达综合', icon: Suitcase, name: 'Mazda', colorClass: 'brown' },
      { index: 12, label: 'SGM综合菜单', icon: Operation, name: 'SgmMenu', colorClass: 'teal' },
    ];

    const permissionMenuItems = computed(() => {
      const items = rawPermissionMenuItems
        .map((item) => ({
          ...item,
          state: item.enabled === false ? 'hidden' : menuItemState(store.state.userData, item.name),
        }))
        .filter((item) => item.state !== 'hidden');

      if (!isSgmUser(store.state.userData)) {
        return items;
      }

      return [
        ...items.filter((item) => item.state === 'enabled'),
        ...items.filter((item) => item.state === 'disabled'),
      ];
    });

    const activeIndex = computed(() => {
      const matched = permissionMenuItems.value.find(item => item.name === route.name);
      return matched ? String(matched.index) : '1';
    });

    const handleMazdaAllClick = () => {
      try {
        router.push({ name: "Mazda" });
        emit("nav-click", { name: "Mazda" });
      } catch (error) {
        ElMessage.error("跳转失败！错误原因:" + error);
      }
    };

    const handleNavClick = (navName) => {
      emit("nav-click", { name: navName });
    };

    const handleMenuItemClick = (item) => {
      if (item.state === 'disabled') {
        ElMessage.warning('当前账号无此菜单权限');
        return;
      }
      emit("nav-click", { name: item.name });
    };

    // 移动端菜单点击
    const handleMobileMenuItemClick = (item) => {
      handleMenuItemClick(item);
    };

    return {
      isMobile,
      showDataSwitchMenu,
      showFordConfigMenu,
      allMenuItems,
      permissionMenuItems,
      activeIndex,
      handleMazdaAllClick,
      handleNavClick,
      handleMenuItemClick,
      handleMobileMenuItemClick,
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style scoped>
/* ========== 通用样式 ========== */
.nav-container {
  height: 100%;
  background: transparent;
}

/* ========== 电脑端样式 ========== */
.desktop-nav {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px 8px;
  background:
    linear-gradient(180deg, rgba(248, 250, 252, 0.96) 0%, rgba(255, 255, 255, 0.98) 100%);
  border-right: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: inset -1px 0 0 rgba(255, 255, 255, 0.9);
}

.nav-header {
  padding: 0 0 12px;
}

.update-meter {
  position: relative;
  overflow: hidden;
  padding: 12px;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  background:
    linear-gradient(135deg, rgba(239, 246, 255, 0.95) 0%, rgba(255, 255, 255, 0.98) 56%, rgba(240, 253, 250, 0.86) 100%);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
}

.update-meter::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(37, 99, 235, 0.08) 1px, transparent 1px),
    linear-gradient(180deg, rgba(15, 23, 42, 0.05) 1px, transparent 1px);
  background-size: 18px 18px;
  opacity: 0.5;
  pointer-events: none;
}

.meter-top,
.meter-main {
  position: relative;
  z-index: 1;
}

.meter-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.meter-label {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.08em;
}

.meter-state {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #047857;
  font-size: 11px;
  font-weight: 700;
}

.meter-state::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #10b981;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.13);
}

.meter-main {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.car-glyph {
  width: 34px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0f172a;
  flex: 0 0 auto;
  filter: drop-shadow(0 5px 8px rgba(15, 23, 42, 0.18));
}

.car-glyph svg {
  width: 29px;
  height: 16px;
  overflow: visible;
}

.car-body,
.car-wheel {
  fill: currentColor;
}

.car-window {
  fill: rgba(148, 232, 255, 0.72);
}

.car-light,
.car-emblem {
  fill: #22d3ee;
}

.car-emblem {
  filter: drop-shadow(0 0 4px rgba(34, 211, 238, 0.8));
}

.meter-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.meter-text {
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.meter-main strong {
  color: #0f172a;
  font-size: 15px;
  line-height: 1.1;
  font-family: "Consolas", "Monaco", monospace;
  white-space: nowrap;
  letter-spacing: 0;
}

.meter-track {
  position: relative;
  z-index: 1;
  height: 4px;
  margin-top: 12px;
  overflow: hidden;
  border-radius: 999px;
  background: #e2e8f0;
}

.meter-track span {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 42%;
  border-radius: inherit;
  background: linear-gradient(90deg, transparent 0%, #2563eb 16%, #06b6d4 56%, #10b981 100%);
  animation: dataSweep 7s ease-in-out infinite;
}

@keyframes dataSweep {
  0% {
    transform: translateX(-120%);
  }

  78% {
    transform: translateX(260%);
  }

  100% {
    transform: translateX(260%);
  }
}

/* 自定义菜单样式 */
.custom-menu {
  border-right: none !important;
  flex: 1;
  background: transparent;
  padding: 4px 0 8px;
  overflow-y: auto;
}

.custom-menu :deep(.el-menu-item) {
  height: 46px;
  margin: 5px 0;
  padding: 0 10px !important;
  border: 1px solid transparent;
  border-radius: 12px;
  color: #475569;
  transition: transform 0.18s ease, background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.custom-menu :deep(.el-menu-item:hover) {
  color: #0f172a;
  background: linear-gradient(135deg, rgba(239, 246, 255, 0.96) 0%, rgba(240, 249, 255, 0.9) 100%);
  border-color: rgba(147, 197, 253, 0.62);
  transform: translateX(3px);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.08);
}

.custom-menu :deep(.el-menu-item.is-active) {
  color: #111827;
  background: linear-gradient(135deg, #dbeafe 0%, #f8fbff 72%);
  border-color: rgba(96, 165, 250, 0.46);
  font-weight: 800;
  box-shadow: inset 3px 0 0 #38bdf8, 0 10px 22px rgba(37, 99, 235, 0.1);
}

.custom-menu :deep(.el-menu-item .el-icon) {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 17px;
  transition: color 0.18s ease, background-color 0.18s ease, transform 0.18s ease;
}

.custom-menu :deep(.el-menu-item.is-active .el-icon) {
  color: #075985;
  background: linear-gradient(135deg, #bae6fd 0%, #dbeafe 100%);
  transform: scale(1.03);
}

.custom-menu :deep(.el-menu-item span) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1;
}

.custom-menu :deep(.el-menu-item:nth-child(1) .el-icon) {
  color: #2563eb;
  background: #eff6ff;
}

.custom-menu :deep(.el-menu-item:nth-child(2) .el-icon) {
  color: #ea580c;
  background: #fff7ed;
}

.custom-menu :deep(.el-menu-item:nth-child(3) .el-icon) {
  color: #059669;
  background: #ecfdf5;
}

.custom-menu :deep(.el-menu-item:nth-child(4) .el-icon) {
  color: #dc2626;
  background: #fef2f2;
}

.custom-menu :deep(.el-menu-item:nth-child(5) .el-icon) {
  color: #7c3aed;
  background: #f5f3ff;
}

.custom-menu :deep(.el-menu-item:nth-child(6) .el-icon) {
  color: #0891b2;
  background: #ecfeff;
}

.custom-menu :deep(.el-menu-item:nth-child(7) .el-icon) {
  color: #db2777;
  background: #fdf2f8;
}

.custom-menu :deep(.el-menu-item:nth-child(8) .el-icon) {
  color: #4f46e5;
  background: #eef2ff;
}

.custom-menu :deep(.el-menu-item:nth-child(9) .el-icon),
.custom-menu :deep(.el-menu-item:nth-child(10) .el-icon) {
  color: #0369a1;
  background: #f0f9ff;
}

/* ========== 手机端1列样式 ========== */
.mobile-nav {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
  padding-bottom: 20px;
}

/* 顶部标题 */
.mobile-header {
  padding: 24px 20px;
  margin-bottom: 16px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  background:
    linear-gradient(135deg, #0f172a 0%, #1e293b 54%, #0f766e 100%);
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.22);
}

.mobile-update-meter {
  color: #ffffff;
}

.mobile-update-meter .meter-label {
  color: rgba(255, 255, 255, 0.62);
}

.mobile-update-meter .meter-main {
  margin-top: 10px;
}

.mobile-update-meter .car-glyph {
  background: rgba(255, 255, 255, 0.14);
  box-shadow: none;
}

.mobile-update-meter .meter-text {
  color: rgba(255, 255, 255, 0.78);
}

.mobile-update-meter .meter-main strong {
  color: #ffffff;
}

/* 1列菜单列表 */
.menu-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px 20px;
}

.list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.02);
}

.list-item:active {
  transform: translateY(1px);
  background-color: #f8f9fa;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.list-item.disabled {
  opacity: 0.52;
  cursor: not-allowed;
}

.list-item.disabled:active {
  transform: none;
}

.item-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.item-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.2s ease;
}

/* 图标背景颜色 */
.item-icon.blue {
  background-color: #ecf5ff;
  color: #409eff;
}

.item-icon.orange {
  background-color: #fdf6ec;
  color: #e6a23c;
}

.item-icon.green {
  background-color: #f0f9eb;
  color: #67c23a;
}

.item-icon.teal {
  background-color: #ecfdf5;
  color: #0f766e;
}

.item-icon.red {
  background-color: #fef0f0;
  color: #f56c6c;
}

.item-icon.purple {
  background-color: #f5f0ff;
  color: #8a6de9;
}

.item-icon.cyan {
  background-color: #e6f7ff;
  color: #13c2c2;
}

.item-icon.pink {
  background-color: #fff0f6;
  color: #eb2f96;
}

.item-icon.indigo {
  background-color: #f0f0ff;
  color: #597ef7;
}

.item-icon.brown {
  background-color: #f7f0e6;
  color: #b85c5c;
}

.item-icon .el-icon {
  font-size: 22px;
}

.item-label {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
}

.item-arrow {
  color: #909399;
  font-size: 16px;
  transition: transform 0.2s ease;
}

.list-item:active .item-arrow {
  transform: translateX(3px);
  color: #409eff;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .desktop-nav {
    display: none;
  }
}

@media screen and (min-width: 769px) {
  .mobile-nav {
    display: none;
  }
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f5f7fa;
}
</style>
